<template>
    <nav id="navigation-account__menu" class="d-block">
        <ul class="navigation-account__menu-list list-unstyled">
            <template v-if="!userHasNoClubs">
                <li class="navigation-account__menu-item">
                    <router-link
                        :to="{ name: $options.ROUTES_HOME }"
                        @click.native="responsiveCloseNav"
                        class="navigation-account__menu-link d-flex align-items-center"
                    >
                        <span class="navigation-account__menu-link-icon navigation-account__menu-link-icon--path-fill">
                            <iconHome />
                        </span>
                        <span class="navigation-account__menu-link-text">{{ $t('home') }}</span>
                    </router-link>
                </li>
                <li class="navigation-account__menu-item">
                    <router-link
                        :to="{ name: $options.ROUTES_PROFILE, params: { id: me.id } }"
                        @click.native="responsiveCloseNav"
                        class="navigation-account__menu-link d-flex align-items-center"
                    >
                        <span
                            class="navigation-account__menu-link-icon navigation-account__menu-link-icon--path-stroke"
                        >
                            <iconAdmin class="d-block" />
                        </span>
                        <span class="navigation-account__menu-link-text">{{ $t('myProfile') }}</span>
                    </router-link>
                </li>
                <li class="navigation-account__menu-item">
                    <router-link
                        :to="{ name: $options.ROUTES_CALENDAR }"
                        @click.native="responsiveCloseNav"
                        class="navigation-account__menu-link d-flex align-items-center"
                    >
                        <span class="navigation-account__menu-link-icon navigation-account__menu-link-icon--path-fill">
                            <iconSession />
                        </span>
                        <span class="navigation-account__menu-link-text">{{ $t('sessions') }}</span>
                    </router-link>
                </li>
                <li class="navigation-account__menu-item" v-if="!isSelectedClubIndividual && isClubDefaultSportWater">
                    <router-link
                        :to="{ name: $options.ROUTES_CREWS_LIST }"
                        @click.native="responsiveCloseNav"
                        class="navigation-account__menu-link d-flex align-items-center"
                    >
                        <span
                            class="navigation-account__menu-link-icon navigation-account__menu-link-icon--path-stroke"
                        >
                            <iconCrews />
                        </span>
                        <span class="navigation-account__menu-link-text">{{ $tc('crew', 2) }}</span>
                    </router-link>
                </li>
                <li class="navigation-account__menu-item" v-if="!isSelectedClubIndividual">
                    <router-link
                        :to="{ name: $options.ROUTES_SQUADS }"
                        @click.native="responsiveCloseNav"
                        class="navigation-account__menu-link d-flex align-items-center"
                    >
                        <span
                            class="navigation-account__menu-link-icon navigation-account__menu-link-icon--path-stroke"
                        >
                            <iconSquads />
                        </span>
                        <span class="navigation-account__menu-link-text">
                            {{ $t('mySquads', { label: squadGroupTranslation(2) }) }}
                        </span>
                    </router-link>
                </li>
                <li class="navigation-account__menu-item" v-if="canViewManageInventory && false">
                    <router-link
                        :to="{ name: $options.ROUTES_EQUIPMENT_LIST }"
                        @click.native="responsiveCloseNav"
                        class="navigation-account__menu-link d-flex align-items-center"
                    >
                        <span class="navigation-account__menu-link-icon navigation-account__menu-link-icon--g-stroke">
                            <iconEquipment />
                        </span>
                        <span class="navigation-account__menu-link-text">{{ $t('equipmentList') }}</span>
                    </router-link>
                </li>
                <li class="navigation-account__menu-item">
                    <router-link
                        :to="{ name: $options.ROUTES_REPORTS }"
                        @click.native="responsiveCloseNav"
                        class="navigation-account__menu-link d-flex align-items-center"
                    >
                        <span class="navigation-account__menu-link-icon navigation-account__menu-link-icon--path-fill">
                            <iconReports />
                        </span>
                        <span class="navigation-account__menu-link-text">{{ $t('reports') }}</span>
                    </router-link>
                </li>
                <li class="navigation-account__menu-item" v-if="canViewClubMembers && !isSelectedClubIndividual">
                    <router-link
                        :to="{ name: $options.ROUTES_CLUB_MEMBERS }"
                        @click.native="responsiveCloseNav"
                        class="navigation-account__menu-link d-flex align-items-center"
                    >
                        <span class="navigation-account__menu-link-icon navigation-account__menu-link-icon--path-fill">
                            <iconClubMembers />
                        </span>
                        <span class="navigation-account__menu-link-text">{{ $t('clubMembers') }}</span>
                    </router-link>
                </li>
                <li class="navigation-account__menu-item" v-if="!isSelectedClubIndividual">
                    <router-link
                        :to="{ name: $options.ROUTES_CHALLENGES }"
                        @click.native="responsiveCloseNav"
                        class="navigation-account__menu-link d-flex align-items-center"
                    >
                        <span
                            class="navigation-account__menu-link-icon navigation-account__menu-link-icon--path-stroke"
                        >
                            <iconChallenge />
                        </span>
                        <span class="navigation-account__menu-link-text">{{ $tc('challenge', 2) }}</span>
                    </router-link>
                </li>
            </template>
        </ul>
    </nav>
</template>

<script>
import { mapGetters } from 'vuex';
import {
    ROUTES_HOME,
    ROUTES_CALENDAR,
    ROUTES_CHALLENGES,
    ROUTES_CLUB_MEMBERS,
    ROUTES_CREWS_LIST,
    ROUTES_EQUIPMENT_LIST,
    ROUTES_PROFILE,
    ROUTES_REPORTS,
    ROUTES_SQUADS
} from '@/constants/routes';
import permissionsMixin from '@/mixins/permissions';
import iconAdmin from '@/assets/img/account/nav-icons/soc-admin.svg?inline';
import iconClubMembers from '@/assets/img/account/nav-icons/nav-club-members.svg?inline';
import iconCrews from '@/assets/img/account/nav-icons/nav-crews.svg?inline';
import iconHome from '@/assets/img/account/nav-icons/nav-home.svg?inline';
import iconReports from '@/assets/img/account/nav-icons/nav-reports.svg?inline';
import iconSession from '@/assets/img/account/nav-icons/nav-session.svg?inline';
import iconSquads from '@/assets/img/account/nav-icons/nav-squads.svg?inline';
import iconEquipment from '@/assets/img/account/nav-icons/nav-equipment.svg?inline';
import iconChallenge from '@/assets/img/account/nav-icons/nac-challenge.svg?inline';

export default {
    ROUTES_CALENDAR,
    ROUTES_CHALLENGES,
    ROUTES_CLUB_MEMBERS,
    ROUTES_CREWS_LIST,
    ROUTES_EQUIPMENT_LIST,
    ROUTES_HOME,
    ROUTES_PROFILE,
    ROUTES_REPORTS,
    ROUTES_SQUADS,

    components: {
        iconAdmin,
        iconClubMembers,
        iconCrews,
        iconHome,
        iconReports,
        iconSession,
        iconSquads,
        iconEquipment,
        iconChallenge
    },

    props: ['responsiveCloseNav'],

    mixins: [permissionsMixin],

    computed: {
        ...mapGetters({
            isSelectedClubIndividual: 'isSelectedClubIndividual',
            isClubDefaultSportWater: 'isClubDefaultSportWater',
            me: 'clubHelper/me',
            userHasNoClubs: 'userHasNoClubs'
        })
    }
};
</script>
